import { useState } from "react";

export default function VocabularyHomePage({
  vocabularyTopics,
  loadingVocabulary,
  openTopic,
  searchVocabulary,
  openSearchResults,
  openReviewDue,
  dueCount,
  loadingDueVocabulary,
  goBackToHome,
  styles,
}) {
  const [searchText, setSearchText] = useState("");
  
  const handleSearch = async () => {
    if (!searchText.trim()) return;

    await searchVocabulary(searchText);
    openSearchResults(searchText);
  };

  return (
    <div style={styles.card}>
      <div style={styles.topBar}>
        <div>
          <h2 style={styles.sectionTitle}>
            Vocabulary
          </h2>

          <div style={styles.quizPath}>
            Study MBLEx vocabulary by topic or search all terms.
          </div>
        </div>

        <button
          style={styles.secondaryButton}
          onClick={goBackToHome}
        >
          Back Home
        </button>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
          marginBottom: "28px",
        }}
      >
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          placeholder="Search English, 中文, Español, Русский..."
          style={{
            ...styles.loginInput,
            flex: 1,
          }}
        />

        <button
          style={styles.smallPrimaryButton}
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      <div
        style={{
          marginBottom: "28px",
          padding: "18px",
          border: "1px solid #e5e7eb",
          borderRadius: "14px",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontWeight: "700",
                fontSize: "18px",
              }}
            >
              Review Due
            </div>

            <div
              style={{
                marginTop: "5px",
                color: "#6b7280",
              }}
            >
              Review vocabulary that is due based on your previous study.
            </div>
          </div>

          <button
            style={styles.smallPrimaryButton}
            onClick={openReviewDue}
            disabled={loadingDueVocabulary}
          >
            {loadingDueVocabulary
              ? "Loading..."
              : dueCount > 0
              ? `Review ${dueCount} Due`
              : "Check Due Words"}
          </button>
        </div>
      </div>

      <h3>Study by Topic</h3>

      {loadingVocabulary ? (
        <div style={styles.emptyBox}>
          Loading vocabulary topics...
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "14px",
          }}
        >
          {vocabularyTopics.map((topic) => (
            <div
              key={topic.id}
              style={{
                padding: "18px",
                border: "1px solid #e5e7eb",
                borderRadius: "14px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
              }}
              onClick={() => openTopic(topic)}
            >
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "18px",
                }}
              >
                {topic.topic_name}
              </div>

              {topic.description && (
                <div
                  style={{
                    marginTop: "8px",
                    color: "#6b7280",
                    lineHeight: "1.5",
                  }}
                >
                  {topic.description}
                </div>
              )}

              <button
                style={{
                  ...styles.smallPrimaryButton,
                  marginTop: "14px",
                }}
              >
                Study Topic
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}